import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurableGridComponent, GridConfig } from '../configurable-grid/configurable-grid.component';
import { MasterDataService } from '../../../Services/master-data.service';
import { BaseInspectionOverview } from 'src/app/DTOs/InspectionMasterData/productDetailModel';

@Component({
  selector: 'app-productdetails',
  standalone: true,
  imports: [CommonModule, ConfigurableGridComponent],
  templateUrl: './productdetails.component.html',
  styleUrls: ['./productdetails.component.css']
})
export class ProductDetailsComponent {
  gridConfig: GridConfig;

  constructor(private masterData: MasterDataService) {
    this.gridConfig = {
      getData: () => this.masterData.getProductDetailsOverview(),
      createItem: (item: BaseInspectionOverview) => this.masterData.createProductDetail(item),
      updateItem: (id: number, item: BaseInspectionOverview) => this.masterData.updateProductDetail(item),
      deleteItem: (id: number) => this.masterData.deleteProductDetail(id)
    };
  }
}